@if (isLoading){
  <div class="bg-white">
    <create-account-placeholder-component [formName]="'Financial Accounts'"></create-account-placeholder-component>
  </div>
  }@else{ @if(selectInstitution){
  <div class="add-subfolder--container add-subfolder--container1 relative">
    <div style="border-bottom: 1px solid rgba(211, 220, 232, 0.7); padding: 20px 20px 8px 20px; margin-bottom: 20px">
      <div class="flex justify-between">
        <div class="text-[#010B18] text-xl font-bold">Accounts at {{ institution?.name }}</div>
        <div>
          <button id="closeConnect-{{ dialogId }}" (click)="closeInstitution()" class="bg-transparent">
            <span class="material-icons text-[#25508E] h-4 w-4">clear</span>
          </button>
        </div>
      </div>
    </div>
    @if (isLoading){
    <create-account-placeholder-component [formName]="data.title"></create-account-placeholder-component>
    } @if (!isLoadingData && !isLoading) {
  <div class="w-full max-h-[calc(100%-160px)] pl-[20px] pr-[20px]">
    <div class="card-container w-full h-full rounded-xl border border-[#e0e0e0] overflow-hidden">
      <div class="flex items-center px-2">
        <div class="mt-2 ml-2 mb-2 rounded">
          <ngx-avatars
            size="30"
            src="{{ mxDatList?.[0]?.institution?.medium_logo_url }}"
            name="{{ mxDatList?.[0]?.institution?.name | titlecase }}"
            initialsSize="2"
            cornerRadius="50"
            [round]="false"
            class="m-1"
          ></ngx-avatars>
        </div>
        <p class="text-[18px] font-semibold font-family-open-sans leading-[44px] m-0 hover:cursor-pointer ml-2">
          {{ institution.name }}
        </p>

        @if(mxDatList?.[0]?.userAccounts?.length > 0){
        <button matTooltipPosition="above" data-dismiss="modal" style="background: transparent; color: #53565b">
          <span class="header-btn-title flex text-[16px] font-weight-[400] text-[#010B18] font-family-open-sans">
            <span class="text-[#010B18] font-weight-[600] mr-2">•</span> {{ mxDatList?.[0]?.userAccounts?.length }} Accounts
          </span>
        </button>
        }
      </div>
      <div class="flex-1 min-h-0 overflow-x-hidden overflow-y-auto pb-4">
        <table class="w-full table-fixed border-collapse personal-files-table" style="min-width: 620px">
          <thead>
            <tr class="text-xs font-semibold text-[#898F9E] bg-white">
              <th class="w-10 border" style="border-color: #e0e0e0; text-align: center">
                <mat-checkbox 
                  aria-label="Select all items" 
                  (change)="onCheckboxChangeAll($event)" 
                  [(ngModel)]="allSelected"
                  *ngIf="!isHeaderCheckboxDisabled()"
                ></mat-checkbox>
                <mat-checkbox aria-label="Select all items" (change)="onCheckboxChangeAll($event)" *ngIf="isHeaderCheckboxDisabled()" checked disabled></mat-checkbox>  
              </th>
              <th class="text-left border pl-2 text-[14px] " style="border-color: #e0e0e0; border-right: none !important; width: 25%; font-weight: 500 !important">Name</th>
              <th class="border text-[14px] " style="border-color: #e0e0e0; border-right: none !important; width: 10%; text-align: center; font-weight: 500 !important">Number</th>
              <th class="border text-[14px] " style="border-color: #e0e0e0; border-right: none !important; width: 15%; text-align: center; font-weight: 500 !important">Balance</th>
              <th class="border text-[14px] " style="border-color: #e0e0e0; border-right: none !important; width: 13%; text-align: center; font-weight: 500 !important">Action</th>
              <th class="border text-[14px] " style="border-color: #e0e0e0; border-right: none !important; width: 17%; text-align: center; font-weight: 500 !important">Template</th>
              <th class="border text-[14px] " style="border-color: #e0e0e0; width: 15%; text-align: center; font-weight: 500 !important">Vault</th>
            </tr>
          </thead>
          <tbody>
            @for (item of getTableDataSource(); track item.id) {
            <tr class="group cursor-pointer">
              <td class="border" style="border-color: #e0e0e0; text-align: center">
                <mat-checkbox
                 *ngIf="!item.vault_user_form_id"
                  (change)="onCheckboxChange($event)"
                  [(ngModel)]="item.checked"
                  (click)="$event.stopPropagation()" 
                  [disabled]="item.action === 'exclude'"
                ></mat-checkbox>
                <mat-checkbox *ngIf="item.vault_user_form_id" checked disabled></mat-checkbox>
              </td>
              <td
                class="text-[#18191C] text-sm font-semibold py-2 px-3 border"
                style="border-color: #e0e0e0; border-right: none !important; width: 25%; max-width: 200px"
              >
                <span class="text-truncate" style="max-width: 200px; display: inline-block; vertical-align: middle">{{ item.name }}</span>
              </td>
              <td
                class="border text-center"
                style="border-color: #e0e0e0; border-right: none !important; width: 10%; padding: 0 16px; font-family: 'Open Sans'; font-size: 14px; color: #18191C; font-weight: 500; line-height: normal; letter-spacing: 0.06px;"
              >
                <div class="app__centered-item justify-around">
                  <span>{{ !item.account_number_hidden ? item.account_number : '****' }}</span>
                  <span matSuffix class="icone-visibility flex items-center bg-transparent text-[18px] leading-none hover:cursor-pointer" (click)="item.account_number_hidden = !item.account_number_hidden">
                    <mat-icon class="text-[18px] mt-2">{{ item.account_number_hidden ? 'visibility' : 'visibility_off' }}</mat-icon>
                  </span>
                </div>
              </td>
              <td
                class="border text-center"
                style="border-color: #e0e0e0; border-right: none !important; width: 15%; padding: 0 16px; font-family: 'Open Sans'; font-size: 14px; font-weight: 500; line-height: normal; letter-spacing: 0.06px; color: #707070;"
              >
                <span>{{ item.account_balance | currency : 'USD' : 'symbol' : '1.2-2' }}</span>
              </td>
              <td class="text-start border" style="border-color: #e0e0e0; border-right: none !important; width: 13%; min-width: 120px; position: relative;" >
                <mat-select [(ngModel)]="item.action" (selectionChange)="onActionChange(item)" disableRipple style="min-width: 120px;font-size: 13px;font-weight: 600;" [disabled]="item.vault_user_form_id">
                  <mat-option value="create">{{ item.vault_user_form_id ? 'In Use' : 'Create New' }}</mat-option>
                  <mat-option value="existing">Select Existing</mat-option>
                  <mat-option value="exclude" style="color: red !important;">Exclude Account</mat-option>
                </mat-select>
                <span class="material-icons" style="position: absolute; right: 8px; top: 50%; transform: translateY(-50%); pointer-events: none; color: #25508E;" [ngStyle]="{'color': item.vault_user_form_id ? '#999' : '#25508E'}">keyboard_arrow_down</span>
              </td>
              <td class="text-center border" style="border-color: #e0e0e0; border-right: none !important; min-width: 120px; position: relative">
                <!-- Custom Template Dropdown (screenshot style) -->
                <div class="template-dropdown-wrapper" [class.disabled]="item.action === 'create' || item.action === 'exclude' || item.vault_user_form_id">
                  <div
                    class="selected-template flex items-center justify-center cursor-pointer min-h-[40px]"
                    (click)="openTemplateDropdown(item)"
                    [class.disabled]="item.vault_user_form_id"
                  >
                    <ng-container *ngIf="item.template || item.vaultUserForm?.form_name; else templatePlaceholder"  class="text-[#18191C] text-sm font-semibold py-2 px-3 cursor-pointer">
                      <span class="font-medium">{{ (item.template?.name || item.template?.type || item.vaultUserForm?.form_name) | truncateStrPipe : 10 }}</span>
                    </ng-container>
                    <ng-template #templatePlaceholder>
                      <span class="text-sm">Template</span>
                    </ng-template>
                    <span class="material-icons ml-2 text-[#25508E]">keyboard_arrow_down</span>
                  </div>
                  
                  <mat-form-field class="absolute top-0 left-0 w-[320px] h-[1px] overflow-hidden opacity-0 pointer-events-none">
                    <input
                      class="w-[320px] min-w-[320px]"
                      matInput
                      [formControl]="item.templateFormControl"
                      [matAutocomplete]="templateAuto"
                      readonly
                    />
                    <mat-autocomplete 
                      #templateAuto="matAutocomplete" 
                      class="search-scroll-main global-search-scroll-main mx-connect-dropdown-panel"
                      (opened)="item.showTemplateDropdown = true"
                      (closed)="item.showTemplateDropdown = false"
                      [displayWith]="null"
                    >
                      <div class="flex items-center px-4 py-2 border-b border-[#eee] bg-[#fafbfc] rounded-t-xl" (click)="$event.stopPropagation()">
                        <img src="assets/images/blue-search-icon.svg" width="18" height="18" class="mr-2" />
                        <input
                          type="text"
                          [(ngModel)]="item.templateSearchText"
                          (input)="filterTemplates(item)"
                          placeholder="Search Templates"
                          class="outline-none w-full text-sm px-1 py-1 bg-transparent border-0"
                          style="box-shadow: none"
                          (click)="$event.stopPropagation()"
                        />
                        <span (click)="item.templateSearchText = ''; filterTemplates(item); $event.stopPropagation()" class="material-icons ml-1 text-[#898F9E] hover:cursor-pointer">clear</span>
                      </div>
                      
                      <div style="height: calc(100vh - 356px); max-height: 320px; overflow-y: auto; padding: 8px 0px 16px 0px">
                        <ng-container *ngIf="templates && templates.length > 0; else showTemplateLoader">
                          <p class="text-[#b0b0b0] text-center py-2" *ngIf="item.filteredTemplates && item.filteredTemplates.length === 0">
                            No results found
                          </p>
                          <div *ngIf="item.filteredTemplates && item.filteredTemplates.length > 0">
                            <div
                              *ngFor="let template of item.filteredTemplates"
                              class="flex justify-between px-4 py-2 bg-white hover:cursor-pointer hover:bg-[#EBF0FA]"
                              (click)="onTemplateSelect(item, template); $event.stopPropagation()"
                            >
                              <div class="flex gap-2">
                                <img *ngIf="template.profile_image_url" [src]="template.profile_image_url" class="bg-[#EBEDFA] p-2 w-9 h-9 rounded"/>
                                <span *ngIf="!template.profile_image_url" class="app__centered-item material-icons w-9 h-9 rounded text-[#b0b0b0] text-2xl">insert_drive_file</span>
                                <div class="flex flex-col items-start">
                                  <p [matTooltip]="template.form_name" class="text-[#18191c] font-semibold text-sm m-0">
                                    {{ template.form_name | truncateStrPipe : 26 }}
                                  </p>
                                  <p [matTooltip]="template.type" class="text-[#707070] text-xs font-normal m-0">
                                    {{ template.type | truncateStrPipe : 25 }}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                        <ng-template #showTemplateLoader>
                          <div class="p-3 text-center text-[#b0b0b0]">No Templates Found</div>
                        </ng-template>
                      </div>
                      <mat-option disabled style="display: none"></mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
              </td>
              <td class="text-start border" style="border-color: #e0e0e0; min-width: 120px; position: relative">
                <!-- Custom Vault Dropdown -->
                <div class="vault-dropdown" [class.disabled]="item.action === 'exclude' || item.vault_user_form_id">
                  <div class="selected-vault w-full flex items-center justify-center cursor-pointer min-h-[40px]" 
                        (click)="openVaultDropdown(item)" 
                        [class.disabled]="item.vault_user_form_id"
                        [class.error-state]="item.action === 'create' && !(item.vault || item.vaultUserForm?.vaultUserFolder?.vault)">
                     <ng-container *ngIf="item.vault || item.vaultUserForm?.vaultUserFolder?.vault; else vaultPlaceholder">
                       <span class="font-semibold" matTooltip="{{ item.vault?.name || item.vaultUserForm?.vaultUserFolder?.vault?.name }}" [class.error-text]="item.action === 'create' && !(item.vault || item.vaultUserForm?.vaultUserFolder?.vault)">{{ item.vault?.name || item.vaultUserForm?.vaultUserFolder?.vault?.name | truncateStrPipe : 10}}</span>
                     </ng-container>
                     <ng-template #vaultPlaceholder>
                       <span class="text-sm" [class.error-text]="item.action === 'create' && !(item.vault || item.vaultUserForm?.vaultUserFolder?.vault)">Select Vault</span>
                     </ng-template>
                     <span class="material-icons ml-2" [class]="item.action === 'create' && !(item.vault || item.vaultUserForm?.vaultUserFolder?.vault) ? 'text-[#EB5757]' : 'text-[#25508E]'">keyboard_arrow_down</span>
                  </div>

                  <mat-form-field class="absolute top-0 left-0 w-[320px] h-[1px] overflow-hidden opacity-0 pointer-events-none">
                    <input
                      class="w-[320px] min-w-[320px]"
                      matInput
                      [formControl]="item.vaultFormControl"
                      [matAutocomplete]="vaultAuto"
                      readonly
                    />
                    <mat-autocomplete 
                      #vaultAuto="matAutocomplete" 
                      class="search-scroll-main global-search-scroll-main mx-connect-dropdown-panel"
                      (opened)="item.showVaultDropdown = true"
                      (closed)="item.showVaultDropdown = false"
                      [displayWith]="null"
                    >
                      <div class="flex items-center px-4 py-2 border-b border-[#eee] bg-[#fafbfc] rounded-t-xl" (click)="$event.stopPropagation()">
                        <img src="assets/images/blue-search-icon.svg" width="18" height="18" class="mr-2" />
                        <input
                          type="text"
                          [(ngModel)]="item.vaultSearchText"
                          (input)="filterVaults(item)"
                          placeholder="Search Vaults"
                          class="outline-none w-full text-sm px-1 py-1 bg-transparent border-0"
                          style="box-shadow: none"
                          (click)="$event.stopPropagation()"
                        />
                        <span (click)="item.vaultSearchText = ''; filterVaults(item); $event.stopPropagation()" class="material-icons ml-1 text-[#898F9E] hover:cursor-pointer">clear</span>
                      </div>
                      
                      <div style="height: calc(100vh - 356px); max-height: 320px; overflow-y: auto; padding: 8px 0px 16px 0px">
                        <ng-container *ngIf="vaults && vaults.length > 0; else showVaultLoader">
                          <p class="text-[#b0b0b0] text-center py-2" *ngIf="item.filteredVaults && item.filteredVaults.length === 0">No results found</p>
                          <div *ngIf="item.filteredVaults && item.filteredVaults.length > 0">
                            <div
                              *ngFor="let vault of item.filteredVaults"
                              class="flex justify-between px-4 py-2 bg-white hover:cursor-pointer hover:bg-[#EBF0FA]"
                              (click)="selectVault(item, vault); $event.stopPropagation()"
                            >
                              <div class="flex gap-2">
                                <div class="bg-[#EBEDFA] p-2 w-9 h-9 rounded flex items-center justify-center">
                                  <img
                                    *ngIf="vault.type === 'personal'"
                                    src="assets/images/vault/personal.svg"
                                    width="32"
                                    height="32"
                                    alt="Personal Vault"
                                  />
                                  <img *ngIf="vault.type === 'shared'" src="assets/images/vault/shared.svg" width="32" height="32" alt="Shared Vault" />
                                  <img
                                    *ngIf="vault.type === 'trust' || vault.type === 'holding' || vault.type === 'entity'"
                                    src="assets/images/vault/entity.svg"
                                    width="32"
                                    height="32"
                                    alt="Entity Vault"
                                  />
                                </div>
                                <div class="flex flex-col items-start">
                                  <p [matTooltip]="vault.name" class="text-[#18191c] font-semibold text-sm m-0"> {{ vault.name | truncateStrPipe : 26 }} </p>
                                  <p [matTooltip]="vault.type + ' Vault'" class="text-[#707070] text-xs font-normal m-0">{{ vault.type | titlecase }} Vault</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                        <ng-template #showVaultLoader>
                          <div class="p-3 text-center text-[#b0b0b0]">Loading...</div>
                        </ng-template>
                      </div>
                      <mat-option disabled style="display: none"></mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
              </td>
            </tr>
            }
            <tr *ngIf="getTableDataSource().length === 0">
              <td colspan="7">
                <div class="flex-center zero-state">
                  <img src="assets/images/no-filse-ingroup.svg" style="height: 90px" />
                  <p class="no-file-text">Nothing to see here</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div
    [class]="
      enable_linking && !allowedOne
        ? 'absolute bottom-4 w-full px-5'
        : (!enable_linking && allowedOne) || !stop_form_creation
        ? 'absolute bottom-[52px] w-full px-5'
        : 'absolute bottom-4 w-full'
    "
  >
    @if(enable_linking){
    <button
      style="min-height: 48px; line-height: 48px"
      class="m-0 p-0 h-11 hover:cursor-pointer rounded-lg"
      [class]="isSaveButtonDisabled() ? 'app__btn--disabled pointer-events-none' : 'app__btn--primary'"
      (click)="linkAccountAssociate()"
      [disabled]="isSaveButtonDisabled()"
    >
      <span>Save</span>
    </button>
    }@else{
    <button
      style="min-height: 48px; line-height: 48px"
      class="m-0 p-0 h-11 hover:cursor-pointer rounded-lg"
      [class]="!account_selected ? 'app__btn--disabled pointer-events-none ' : 'app__btn--primary'"
      (click)="linkAccount()"
    >
      <span> Continue</span>
    </button>
    }
  </div>
    } @else if(isLoadingData && !isLoading){
    <div class="loader-container px-[20px]" style="flex-direction: column">
      @for (item of loaderItems; track item) {
      <div>
        <div class="flex loader-body" id="{{ item.id }}" style="width: 100%">
          <div class="ph-item width-100per loader-body-item" style="padding-top: 24px">
            <div class="ph-col-12" style="padding: 0px !important">
              <div class="ph-row">
                <div class="ph-col-12" style="height: 30px; padding: 0px; margin: 0px"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
    } @if(enable_linking && !allowedOne) {
    <ng-container></ng-container>
    }@else{
    <ng-container *ngTemplateOutlet="footerTemplateReference"></ng-container>
    }
    <!-- <div class="checklist-floater" *ngIf="selectedAccounts?.length >= 2 && !isLoading && !multiVaultSelected">
      <mx-floater-action
        [selectedAccounts]="selectedAccounts"
        (onSelectVault)="onSelectVault()"
        (onClearSelection)="onClearSelection()"
      ></mx-floater-action>
    </div> -->
  </div>
  }@else{
  <div class="add-subfolder--container relative">
    <div style="border-bottom: 1px solid rgba(211, 220, 232, 0.7); padding: 12px; margin-bottom: 12px">
      <div class="flex items-center justify-between">
        <h2 class="mx-title">{{ title }}</h2>
        <div class="flex items-center gap-1">
          @if(showContextText){
          <button mat-icon-button tabindex="-1" (click)="minimizeMxDialog()">
            <mat-icon>minimize</mat-icon>
          </button>
          }
          <div class="web-close-icon">
            <button id="clearConnect-{{ dialogId }}" mat-icon-button (click)="closeDialog()" class="web-close-btn">
              <span class="material-icons" style="position: relative">clear</span>
            </button>
            <button id="successDialog-{{ dialogId }}" mat-icon-button style="display: none" (click)="successDialog()" class="web-close-btn">
              <span class="material-icons" style="position: relative">clear</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    @if(showContextText){
    <div class="connecting-cards-container w-[95%] h-[54px] mx-auto relative overflow-hidden">
      <div class="connecting-cards-carousel">
        <div class="connecting-card-item">
          <span class="connecting-card-text">One moment while we connect to this financial institution...</span>
        </div>
        <div class="connecting-card-item">
          <span class="connecting-card-text">We are gathering data for all the accounts this institution, as well as 3 months of transactions...</span>
        </div>
        <div class="connecting-card-item">
          <span class="connecting-card-text">This could take a couple of minutes if there are many accounts at this institution...</span>
        </div>
        <div class="connecting-card-item">
          <span class="connecting-card-text">You might need to authenticate this connection, depending on security settings at this institution</span>
        </div>
        <div class="connecting-card-item">
          <span class="connecting-card-text"
            >You can minimize this popup and continue with onboarding and we'll let you know when things are ready</span
          >
        </div>
      </div>
    </div>
    }
    <div
      id="widget-{{ dialogId }}"
      class="w-[96%] max-h-[calc(84%-50px)] m-auto overflow-auto mt-2"
      [style.display]="!hideMxWidget ? 'block' : 'none'"
      #mxIframeContainer
    ></div>
    @if(showFooter){
    <ng-container *ngTemplateOutlet="footerTemplateReference"></ng-container>
    } @if (mxIframeContainer.offsetHeight == 0 || hideMxWidget) {
    <div>
      <div class="flex w-[90%] loader-body m-auto mt-10">
        <div class="ph-item width-100per loader-body-item" style="padding-top: 16px">
          <div class="ph-col-12" style="padding: 0px !important">
            <div class="ph-row">
              <div style="height: 24px" class="ph-col-12"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
  }

  <ng-template #footerTemplateReference>
    <div
      style="box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.06)"
      [class]="
        selectInstitution
          ? 'app__centered-item absolute bottom-0 w-full h-[52px] bg-[#ebf0fa] rounded-b-[10px] text-center'
          : 'app__centered-item absolute bottom-0 w-full ml-[-12px] h-[52px] bg-[#ebf0fa] rounded-b-[10px] text-center'
      "
    >
      <span
        class="app__form--attribute--title w-[65%] text-[12px] font-medium leading-[1.25rem]"
        style="text-decoration-skip-ink: none; text-underline-position: from-font"
      >
        If you face any issues or delays connecting to a financial institution,
        <span
          class="font-bold text-[#5475c0] hover:cursor-pointer"
          style="text-decoration-line: underline; text-decoration-style: solid"
          (click)="handleHelpLink()"
        >
          Please let us know.
        </span>
      </span>
    </div>
  </ng-template>
}
